import React from 'react';
import SEO from '../components/SEO';
import './TermsConditions.css';

const TermsConditions = () => {
  return (
    <div className="terms-conditions-page">
      <SEO 
        title="Terms & Conditions - AppShow | User Agreement & App Usage Terms"
        description="Read AppShow's Terms & Conditions covering user responsibilities, intellectual property, in-app purchases, privacy, and usage guidelines for all our mobile applications."
        keywords="terms and conditions, user agreement, app terms, mobile app terms, usage policy, legal terms, app store terms"
        url="/terms"
      />
      <div className="container">
        <header className="terms-header">
          <h1>Terms & Conditions</h1>
          <p className="last-updated">Last updated: January 15, 2025</p>
        </header>

        <div className="terms-content">
          <section className="terms-section">
            <h2>1. Acceptance of Terms</h2>
            <p>
              By downloading, installing, or using any mobile application developed by Helie (Sole Proprietor), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our applications.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Description of Service</h2>
            <p>
              We provide mobile applications designed to enhance various aspects of users' personal lives. Our applications may include tracking features, analytics, educational content, and premium features available through in-app purchases.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Age Restrictions</h2>
            <p>
              Some of our applications are intended for users aged 18 and above. By using these applications, you confirm that you meet the minimum age requirement. Applications containing mature content are clearly marked and restricted accordingly.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. User Responsibilities</h2>
            <p>
              You agree to:
            </p>
            <ul>
              <li>Use the applications in compliance with applicable laws</li>
              <li>Provide accurate information when required</li>
              <li>Maintain the security of your device and data</li>
              <li>Not reverse engineer or modify the applications</li>
              <li>Not use the applications for illegal purposes</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>5. Intellectual Property</h2>
            <p>
              All content, features, and functionality of our applications are owned by Helie (Sole Proprietor) and are protected by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Privacy and Data</h2>
            <p>
              Your privacy is important to us. Please review our Privacy Policy to understand how we collect, use, and protect your information. Most of our applications store data locally on your device for maximum privacy.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. In-App Purchases</h2>
            <p>
              Some applications offer premium features through in-app purchases. All purchases are processed through the respective app store (Apple App Store or Google Play Store) and are subject to their terms and refund policies.
            </p>
          </section>

          <section className="terms-section">
            <h2>8. Disclaimer of Warranties</h2>
            <p>
              Our applications are provided "as is" without warranties of any kind. We do not guarantee that the applications will be error-free, secure, or continuously available.
            </p>
          </section>

          <section className="terms-section">
            <h2>9. Limitation of Liability</h2>
            <p>
              To the maximum extent permitted by law, Helie (Sole Proprietor) shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our applications.
            </p>
          </section>

          <section className="terms-section">
            <h2>10. Termination</h2>
            <p>
              We may terminate or suspend your access to our applications at any time for violation of these terms. You may terminate your use by uninstalling the applications from your device.
            </p>
          </section>

          <section className="terms-section">
            <h2>11. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms and Conditions at any time. Updated terms will be posted within the applications and on our website. Continued use constitutes acceptance of the modified terms.
            </p>
          </section>

          <section className="terms-section">
            <h2>12. Contact Information</h2>
            <p>
              For questions regarding these Terms and Conditions, please contact us:
            </p>
            <div className="contact-info">
              <p><strong>Email:</strong> roboencode@gmail.com</p>
              <p><strong>Business Name:</strong> Helie (Sole Proprietor)</p>
            </div>
          </section>

          <div className="terms-footer">
            <p>
              These Terms and Conditions are effective as of the date stated above.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;


